var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollarWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.45,
    y: 0.45,
    width: 17.1,
    height: 17.1,
    rx: 8.55,
    stroke: "white",
    strokeOpacity: 0.7,
    strokeWidth: 0.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.894 13.6764C8.2556 13.6764 7.6844 13.563 7.1804 13.3362C6.6764 13.1094 6.2774 12.7692 5.9834 12.3156C5.6978 11.8536 5.555 11.2782 5.555 10.5894V10.3248H6.6008V10.5894C6.6008 11.3202 6.815 11.8662 7.2434 12.2274C7.6718 12.5802 8.222 12.7566 8.894 12.7566C9.5828 12.7566 10.1078 12.6012 10.469 12.2904C10.8302 11.9796 11.0108 11.589 11.0108 11.1186C11.0108 10.791 10.931 10.5306 10.7714 10.3374C10.6118 10.1442 10.385 9.9888 10.091 9.8712C9.797 9.7452 9.4526 9.636 9.0578 9.5436L8.39 9.3798C7.8776 9.2454 7.424 9.0816 7.0292 8.8884C6.6344 8.6952 6.3236 8.4432 6.0968 8.1324C5.8784 7.8132 5.7692 7.4058 5.7692 6.9102C5.7692 6.4146 5.8952 5.9862 6.1472 5.625C6.3992 5.2638 6.7478 4.9866 7.193 4.7934C7.6382 4.6002 8.159 4.5036 8.7554 4.5036C9.3518 4.5036 9.8852 4.6086 10.3556 4.8186C10.826 5.0202 11.1998 5.3226 11.477 5.7258C11.7542 6.1206 11.8928 6.6204 11.8928 7.2252V7.7544H10.847V7.2252C10.847 6.7968 10.7546 6.4524 10.5698 6.192C10.3934 5.9316 10.1456 5.7384 9.8264 5.6124C9.5156 5.4864 9.1586 5.4234 8.7554 5.4234C8.1758 5.4234 7.7096 5.5536 7.3568 5.814C7.004 6.066 6.8276 6.4272 6.8276 6.8976C6.8276 7.2084 6.899 7.4604 7.0418 7.6536C7.193 7.8468 7.4072 8.0064 7.6844 8.1324C7.9616 8.25 8.2934 8.355 8.6798 8.4474L9.3476 8.6112C9.8516 8.7204 10.3094 8.8716 10.721 9.0648C11.1326 9.2496 11.456 9.5058 11.6912 9.8334C11.9348 10.1526 12.0566 10.5726 12.0566 11.0934C12.0566 11.6142 11.9264 12.0678 11.666 12.4542C11.4056 12.8406 11.036 13.143 10.5572 13.3614C10.0868 13.5714 9.5324 13.6764 8.894 13.6764ZM8.4152 14.9616V3.2184H9.3854V14.9616H8.4152Z",
    fill: "white",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarWhiteIcon);
export default __webpack_public_path__ + "static/media/dollarWhiteIcon.4c1aec18a880f4897fe12603a3720b8b.svg";
export { ForwardRef as ReactComponent };